import { Button } from '@repo/shadcn';
import { Menu } from 'lucide-react';
import { Dispatch, SetStateAction } from 'react';

type HeaderStartProps = {
    isCollapsed: boolean;
    setIsCollapsed: Dispatch<SetStateAction<boolean>>;
};

export const HeaderStart = ({
    isCollapsed: _isCollapsed,
    setIsCollapsed,
}: HeaderStartProps) => {
    return (
        <div>
            <Button
                variant={'link'}
                size={'icon'}
                type="button"
                onClick={() => setIsCollapsed((prevState) => !prevState)}
            >
                <Menu />
            </Button>
        </div>
    );
};
